var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_73_2480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6429 18H24.3435C21.9471 18 20 19.9743 20 22.398V74.602C20 77.0257 21.9471 79 24.3435 79H76.6429C79.0393 79 81 77.0257 81 74.602V22.398C81 19.9743 79.0393 18 76.6429 18ZM38.4362 70.2857H29.3951V41.1746H38.4498V70.2857H38.4362ZM33.9156 37.1987C31.0154 37.1987 28.6734 34.8431 28.6734 31.9565C28.6734 29.0699 31.0154 26.7143 33.9156 26.7143C36.8022 26.7143 39.1578 29.0699 39.1578 31.9565C39.1578 34.8567 36.8158 37.1987 33.9156 37.1987ZM72.3266 70.2857H63.2855V56.125C63.2855 52.7482 63.2174 48.4047 58.588 48.4047C53.8768 48.4047 53.1551 52.081 53.1551 55.8799V70.2857H44.1141V41.1746H52.7875V45.1504H52.91C54.1219 42.8629 57.0766 40.4529 61.4746 40.4529C70.6246 40.4529 72.3266 46.4848 72.3266 54.3277V70.2857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_73_2480",
    x: 0,
    y: 0,
    width: 101,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_73_2480"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_2480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73_2480",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedinIcon);
export default __webpack_public_path__ + "static/media/Footer_linkedin_icon.da68614ec5860425588ad9d2af491adb.svg";
export { ForwardRef as ReactComponent };